var _path, _g, _path2, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalInfoicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2269_34838",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 11,
    width: 14,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66669 11.6328H14.3199V17.5491H1.66669V11.6328Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2269_34838)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99317 12.8828C5.67734 12.8828 2.9165 13.1803 2.9165 14.6011C2.9165 15.7278 4.62484 16.2995 7.99317 16.2995C11.3615 16.2995 13.0698 15.722 13.0698 14.5845C13.0698 13.4553 11.3615 12.8828 7.99317 12.8828ZM7.99317 17.5495C6.26317 17.5495 1.6665 17.5495 1.6665 14.6011C1.6665 11.6328 6.42817 11.6328 7.99317 11.6328C10.709 11.6328 14.3198 11.9386 14.3198 14.5845C14.3198 17.5495 9.55817 17.5495 7.99317 17.5495Z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9932 2.91797C6.32236 2.91797 4.9632 4.27714 4.9632 5.94714C4.9632 7.61714 6.32236 8.9763 7.9932 8.9763H8.01903C8.82236 8.97297 9.57903 8.65714 10.1465 8.08464C10.7149 7.5138 11.0257 6.75464 11.0224 5.94964C11.0224 4.27714 9.6632 2.91797 7.9932 2.91797ZM7.9932 10.2263C5.6332 10.2263 3.7132 8.3063 3.7132 5.94714C3.7132 3.58797 5.6332 1.66797 7.9932 1.66797C10.3524 1.66797 12.2724 3.58797 12.2724 5.94714C12.2774 7.0838 11.8365 8.15714 11.0332 8.96547C10.2315 9.77464 9.1607 10.2221 8.02153 10.2263H7.9932Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7353 9.27891C13.4287 9.27891 13.1612 9.05308 13.117 8.74058C13.0695 8.39891 13.307 8.08225 13.6487 8.03475C14.6887 7.88891 15.4737 6.98641 15.4753 5.93475C15.4753 4.88975 14.727 4.00808 13.6978 3.83975C13.357 3.78308 13.1262 3.46225 13.182 3.12141C13.2378 2.78058 13.5603 2.55141 13.8995 2.60558C15.537 2.87391 16.7253 4.27475 16.7253 5.93558C16.722 7.60641 15.4745 9.04141 13.8228 9.27308C13.7937 9.27725 13.7645 9.27891 13.7353 9.27891Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2269_34838",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 11,
    width: 5,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.871 11.2383H18.3158V15.3862H14.871V11.2383Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2269_34838)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5796 15.3862C16.3271 15.3862 16.0896 15.2321 15.9954 14.9829C15.8729 14.6604 16.0354 14.2987 16.3579 14.1771C17.0663 13.9087 17.0663 13.5812 17.0663 13.4412C17.0663 12.9687 16.5071 12.6454 15.4046 12.4812C15.0629 12.4296 14.8271 12.1112 14.8779 11.7704C14.9296 11.4287 15.2538 11.1996 15.5888 11.2437C17.8438 11.5812 18.3163 12.6254 18.3163 13.4412C18.3163 14.0487 18.0538 14.8712 16.8013 15.3454C16.7288 15.3729 16.6538 15.3862 16.5796 15.3862Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfoicons);
export default __webpack_public_path__ + "static/media/PersonalInfoicons.6bfb8116c7d8915ed977ddb016c1adf7.svg";
export { ForwardRef as ReactComponent };